module.exports = __webpack_public_path__ + "img/img8.e46fa854.png";